import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { ecosystemPartners } from '@/mocks/evidence';

export default function Ecosystem() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="合作生态"
            title="「1+3」联合体协同共建"
            subtitle="慈商科技、三明词元、纽盾科技、欣阳通力与华辉数智技术，构成九畴云市的产业生态联合体。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-4">
          {ecosystemPartners.map((p, i) => (
            <Reveal key={p.name} delay={i * 60}>
              <div
                className={`h-full p-5 rounded-lg border text-center transition-colors ${
                  p.highlight
                    ? 'bg-primary-500 border-primary-500 text-background-50'
                    : 'bg-background-50 border-background-200 hover:border-accent-300 text-foreground-950'
                }`}
              >
                <div
                  className={`font-heading font-bold text-base ${
                    p.highlight ? 'text-background-50' : 'text-foreground-950'
                  }`}
                >
                  {p.name}
                </div>
                <div
                  className={`mt-2 text-xs leading-relaxed ${
                    p.highlight ? 'text-background-200' : 'text-foreground-500'
                  }`}
                >
                  {p.role}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}